var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLongLoadingCheck = function SvgLongLoadingCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 128,
    height: 128,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#827127",
    d: "M40.27 23.25c22.24-12.84 50.68-5.22 63.52 17.02 12.841 22.241 5.221 50.68-17.02 63.521-22.24 12.841-50.68 5.22-63.52-17.02s-5.22-50.68 17.02-63.52m44.175 76.514c20.017-11.557 26.875-37.152 15.318-57.168C88.207 22.579 62.612 15.72 42.595 27.278 22.58 38.834 15.721 64.429 27.277 84.446c11.557 20.016 37.152 26.875 57.168 15.318"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#827127",
    stroke: "#827127",
    d: "M79.27 51.861a2.473 2.473 0 0 1 1.749 4.221l-.354.353-.004-.003-20.645 20.646a2.47 2.47 0 0 1-3.318.163l-.18-.163-9.187-9.187a2.472 2.472 0 0 1 3.497-3.497l7.44 7.442 19.254-19.251a2.47 2.47 0 0 1 1.748-.724Z"
  })));
};
export default SvgLongLoadingCheck;